module.exports = __webpack_public_path__ + "static/media/button_dropdown.395ac374.svg";